<template>
    <div>
      <div class="loading" v-if="loadingStatus === 'loading'">
        <a-spin
          :spinning="loadingStatus === 'loading'"
        ></a-spin>
      </div> 
      <div v-else>
        <div class="head_navigation">
            <a-button class="navCurrent">全部</a-button>
            <a-button @click="handlePresetType('effects')">特效</a-button>
            <a-button @click="handlePresetType('lottiefiles')">动画</a-button>
            <a-popover trigger="hover" placement="right" >
              <template #content>
              <template v-for="(item,index) in materialtypeName">
                <p :key="index" v-if="
                index=='assemblyList'||
                index=='postList'||
                index=='backgroundList'||
                index=='materialList'
                "
                class="navCurrentP"
                @click="handlePresetType(item.value)"
                >
                  {{item.name}}
                </p>
              </template>
              </template>
              <a-button>更多</a-button>
            </a-popover>
        </div>
        <div v-for="(item,index) in libraryList" :key="index">
            <div class="material__head">
              <div class="material__typeName">
                  {{materialtypeName[index].name}}
              </div>
              <div class="material__all" @click="handlePresetType(materialtypeName[index].value)">查看全部</div>
            </div>
            <div>
                <template v-if="index=='animationList'||index=='specialList'">
                    <lottie-preview
                        v-for="itemtwo in item"
                        :item="itemtwo"
                        :key="itemtwo.id"
                        :class="index === 'specialList' ? 'effect-sticker-item' : 'sticker-item'"
                        :url="itemtwo.url"
                        :lottieId="itemtwo.id"
                        :attributeName="itemtwo.attribute_name"
                        @click.native="onClickItem('lottie', itemtwo, index)"
                    />
                </template>
                <template v-if="index=='postList'">
                  <div
                    v-for="itemtwo in item"
                    :key="itemtwo.id"
                    class="sticker-item"
                    @click="onClickItem('2', itemtwo)"
                  >
                    <span
                      class="tem_used_icon"
                      :class="{ block: item.is_collect }"
                      :title="itemtwo.is_collect ? '取消收藏' : '收藏'"
                      :style="{
                        'background-image': itemtwo.is_collect
                          ? 'url(/preview/icon/icon_collected.png)'
                          : 'url(/preview/icon/icon_collect.png)'
                      }"
                    ></span>
                    <img
                      v-if="itemtwo.attribute_name == '标准'"
                      title="标准"
                      class="meal-icon"
                      src="/preview/icon/user_meal1.png"
                      alt="标准"
                    />
                    <img
                      v-else-if="itemtwo.attribute_name == '专业'"
                      class="meal-icon"
                      title="专业"
                      src="/preview/icon/user_meal2.png"
                      alt="专业"
                    />
                    <img
                      v-else-if="itemtwo.attribute_name == '旗舰'"
                      class="meal-icon"
                      title="旗舰"
                      src="/preview/icon/user_meal3.png"
                      alt="旗舰"
                    />
                    <div class="sticker-item__content" :style="stickerStyle(itemtwo)" />
                  </div>
                </template>
                <template v-if="index=='materialList'">
                  <MaterialStyleList
                    ref="backgroundMaterialList"
                    :dataList="item"
                    :fn="addMaterialItem"
                    :editStatus="false"
                    :mine="false"
                    :liFisherActive="false"
                  />
                </template>
                <template v-if="index=='assemblyList'">
                    <div
                      v-for="itemtwo in item"
                      :key="itemtwo.id"
                      class="video-template-item"
                      @click="onClickItem('1', itemtwo)"
                    >
                      <img
                        v-if="itemtwo.attribute_name == '标准'"
                        title="标准"
                        class="meal-icon"
                        src="/preview/icon/user_meal1.png"
                        alt="标准"
                      />
                      <img
                        v-else-if="itemtwo.attribute_name == '专业'"
                        class="meal-icon"
                        title="专业"
                        src="/preview/icon/user_meal2.png"
                        alt="专业"
                      />
                      <img
                        v-else-if="itemtwo.attribute_name == '旗舰'"
                        class="meal-icon"
                        title="旗舰"
                        src="/preview/icon/user_meal3.png"
                        alt="旗舰"
                      />
                      <img
                        v-if="itemtwo.thumbnail"
                        :src="itemtwo.thumbnail + '?x-oss-process=image/resize,w_216'"
                        alt="Preset Preview"
                        class="video-clip-custom-img"
                      />
                      <div v-else class="video-clip-custom-img" />
                      <div :title="itemtwo.name" class="video-clip-custom-title">
                        {{ itemtwo.name }}
                      </div>
                    </div>
                </template>
                <template v-if="index=='backgroundList'">
                  <div
                    v-for="itemtwo in item"
                    :key="itemtwo.id"
                    class="video-template-item"
                  >
                    <img
                      v-if="itemtwo.attribute_name == '标准'"
                      title="标准"
                      class="meal-icon"
                      src="/preview/icon/user_meal1.png"
                      alt="标准"
                    />
                    <img
                      v-else-if="itemtwo.attribute_name == '专业'"
                      class="meal-icon"
                      title="专业"
                      src="/preview/icon/user_meal2.png"
                      alt="专业"
                    />
                    <img
                      v-else-if="itemtwo.attribute_name == '旗舰'"
                      class="meal-icon"
                      title="旗舰"
                      src="/preview/icon/user_meal3.png"
                      alt="旗舰"
                    />
                    <div class="background-previewer" v-if="itemtwo.thumbnail">
                      <img
                        :src="backgroundThumbnail(itemtwo)"
                        alt="Preset Preview"
                        class="video-clip-custom-img"
                        @click="addBackground(itemtwo)"
                      />
                      <a-button
                        class="background-previewer__btn"
                        :icon="itemtwo.type === '9' ? 'caret-right' : 'zoom-in'"
                        type="link"
                        @click="previewBackground(itemtwo)"
                      />
                    </div>
                    <div
                      v-else
                      class="video-clip-custom-img"
                      @click="addBackground(itemtwo)"
                    />
                    <div
                      :title="itemtwo.name"
                      class="video-clip-custom-title"
                      @click="addBackground(itemtwo)"
                    >
                      {{ itemtwo.name }}
                    </div>
                  </div>
                </template>
                <template v-if="index=='icons'">
                  <div class="icon-list">
                    <!-- something went wrong -->
                    <div
                      class="icon-list__item"
                      v-for="params in displayList"
                      :key="params.icon"
                    >
                        <button
                          class="icon-list__btn"
                          type="button"
                          @click="handleIconAdd(params)"
                        >
                          <icon-renderer
                            :params="params"
                            effectId="test"
                            class="icon-list__icon"
                          />
                        </button>
                        <a-popover placement="rightTop" overlayClassName="shape-menu-overlay">
                          <template slot="content">
                            <p class="shape-menu-overlay__name">{{ params.icon }}</p>
                            <p class="shape-menu-overlay__desc">可用风格: {{ params.allThemes }}</p>
                          </template>
                          <a-button class="material-action-trigger" type="link">
                            <a-icon type="ellipsis" />
                          </a-button>
                        </a-popover>
                    </div>
                  </div>
                </template>
            </div>
        </div>
      </div>
      <material-preview-modal
        :visible.sync="backgroundPreviewVisible"
        :material="previewingBackground"
      />
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { get } from "../../utils/api";
import LottiePreview from "./LottiePreview";
import MaterialStyleList from "../base/MaterialStyleList";
import MaterialPreviewModal from '../../series/MaterialPreviewModal';
import { encodeURIIfNeeded, getImageAspectRatio, getVideoAspectRatio } from "../../utils";
import iconList, { themeNames } from '../../utils/iconList';
import IconRenderer from '../player/IconRenderer';
const allIcons = {
  Fill: [],
  Outline: [],
  TwoTone: []
};

Object.keys(iconList).forEach(k => {
  const themes = iconList[k];
  themes.forEach(t => {
    allIcons[t].push({
      width: 40,
      height: 40,
      theme: t,
      allThemes: themes.map(v => themeNames[v]).join(', '),
      icon: k,
      color: 'var(--color)',
      secondaryColor: 'var(--secondary)'
    });
  });
});
export default {
  name: "MaterialLibraryList",
  components: {
    LottiePreview,
    MaterialStyleList,
    MaterialPreviewModal,
    IconRenderer
  },
  data: function () {
    return{
      materialtypeName:{
        'specialList':{
          name:'特效',
          value: 'effects'
        },
        'animationList':{
          name:'动画',
          value: 'lottiefiles'
        },
        'assemblyList':{
          name:'组件',
          value: '1'
        },
        'postList':{
          name:'贴纸',
          value: '2',
        },
        'backgroundList':{
          name:'背景',
          value: 'background',
        },
        'materialList':{
          name:'系统素材',
          value: 'materials'
        },
        'icons':{
          name:'系统icon',
          value: 'icons'
        },
      },
      libraryList:[],
      backgroundPreviewVisible: false,
      previewingBackground: null,
      loadingStatus: "loaded",
      displayList:[]
    }
  },
  conputed: {
  },
  methods:{
    ...mapActions(
      ['addMaterialItem']
    ),
    handleIconAdd(item) {
      this.$store.dispatch('addIconItem', item);
    },
    getList(){
      this.loadingStatus = 'loading';
      return get('material/library').then((data) => {
          this.libraryList = data;
          this.libraryList['icons'] = [];
          this.loadingStatus='loaded';
      });
    },
    handlePresetType(type){
      console.log(type)
      this.$emit('clickPresetType',type)
    },
    onClickItem(type, item, index) {
      var lottieType = index =='specialList'?2:1
      var data  = {
        type,
        item,
        lottieType
      }
      this.$emit('handleItem',data)
    },
    stickerStyle(item) {
      const url = item.thumbnail;
      return {
        backgroundImage: `url(${encodeURIIfNeeded(url)})`,
      };
    },
    previewBackground(item) {
      const type = item.type === '8' ? '1' : '2';
      this.backgroundPreviewVisible = true;
      this.previewingBackground = {
        material_type: type,
        material_url: item.thumbnail
      };
    },
    backgroundThumbnail(item) {
      console.log(item)
      return item.type === '8'
        ? item.thumbnail + '?x-oss-process=image/resize,w_216'
        : item.thumbnail + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_216';
    },
    async addBackground(item) {
      const { editingContainer, screenRatio, effects } = this.$store.state;
      const { activeFragment: frag } = this.$store.getters;
      const type = item.type === '8' ? 'image' : 'video';
      const key = Date.now() + '';
      let ownDuration = 0;
      this.$store.commit('handleLoading', true);
      const ratio = await (
        type === 'video' ? getVideoAspectRatio(item.thumbnail, video => {
          ownDuration = video.duration;
        }) : getImageAspectRatio(item.thumbnail)
      );
      this.$store.commit('handleLoading', false);

      const usedWidth = Math.min(400 * (ratio || 1.5), screenRatio * 480);
      const height = usedWidth / ratio;

      const left = editingContainer ? 0 : (screenRatio * 480 - usedWidth) / 2;
      const top = editingContainer ? 0 : (480 - height) / 2;

      const effect = {
        id: key,
        type,
        locked: false,
        hidden: false,
        content: {
          src: item.thumbnail,
          name: item.name,
          top,
          left,
          width: usedWidth,
          height,
          rotate: 0,
          brightness: 1,
          opacity: 100,
          flip: 'none',
          shadow: false,
          shadowX: 1,
          shadowY: 3,
          shadowBlur: 5,
          shadowColor: '#000000',
          radius: 0
        },
        enter: 'none',
        enterDuration: 1e3,
        leave: 'none',
        leaveDuration: 1e3,
        showTracks: false,
        duration: frag.duration,
        start: 0,
        tracks: [
          {
            id: 1,
            start: 1e3,
            duration: 1e3,
            text: 'animation',
            effectType: 'gradientFade',
            params: {
              direction: 'left'
            }
          }
        ]
      };
      if (type === 'video') {
        effect.content.loop = true; // loop by default
        effect.content.mute = false;
        effect.content.volume = 100;
        effect.content.musicVolume = 100;
        // effect.duration = Math.min(ownDuration, frag.duration - currentProgress + frag.start);
        effect.content.crop = [0, ownDuration];
        effect.content.playbackRate = 1;
      } else {
        effect.content.repeat = false;
      }
      this.$store.commit('handleEffects', {
        ...effects,
        [key]: effect
      });

      this.$store.dispatch('changeActiveFragment', {
        ...frag,
        background: key,
        backgroundType: type
      });

      this.$store.dispatch('selectBackground');
    },
  },
  mounted() {
    var _t =this;
    _t.displayList = allIcons['Outline'].slice(0,3);
    this.getList();
  },
  beforeDestroy() {
  },
  wacth:{}
};
</script>
<style>
.material__head{
  display: flex;
  justify-content: space-between;
  padding:10px 0;
}
.material__typeName{
  color:#333;
  font-size: 14px;
  font-weight: bold;
}
.material__all{
  cursor: pointer;
}
.sticker-item {
  width: 27%;
  height: 6vh;
  margin: 11px 11px 0 0;
  position: relative;
  background: #fff
    url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCAyIDIiPjxwYXRoIGQ9Ik0wIDBMMCAxTDIgMUwyIDJMMSAyTDEgMHoiIGZpbGw9InJnYmEoMCwwLDAsLjIpIi8+PC9zdmc+);
  background-size: 12px;
  display: inline-block;
}
.sticker-item:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sticker-item:after {
  content: "";
  transition: 0.3s;
}

.sticker-item:hover:after {
  box-shadow: inset 0 0 0 2px #007eff;
}

.effect-sticker-item {
  width: 27%;
  height: 37px;
  margin: 11px 14px 0 0;
  position: relative;
  background: url(https://img001.aivideo8.com/ai_video/U449/2021-07-23/img/1627005227557.jpg)
    no-repeat;
  background-size: cover;
  display: inline-block;
}
.sticker-item__content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.video-template-item {
  margin: 12px 9px 6px 0;
  width: 27%;
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.meal-icon {
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.video-clip-custom-img{
  object-fit: cover;
  width: 100%;
  height: 60px;
  transition: 0.2s;
}
.video-clip-custom-title {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  padding-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.loading{
  width: 100%;
  height:50vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.head_navigation{
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.navCurrent{
  border-color: #40a9ff;
  background:#40a9ff;
  color:#fff;
}
.navCurrentP{
  cursor: pointer;
}
.icon-list {
  display: flex;
  flex-wrap: wrap;
  margin-right: -14px;
}

.icon-list__item {
  flex-shrink: 0;
  width: calc(100% / 3 - 14px);
  margin-right: 14px;
  margin-top: 11px;
  font-size: 12px;
  --color: #616161;
  --secondary: #e4e4e4;
  position: relative;
}

.icon-list__item:hover .material-action-trigger {
  opacity: 0.7;
}

.icon-list__item .material-action-trigger:hover,
.icon-list__item .material-action-trigger:focus {
  opacity: 1;
}

.icon-list__btn {
  background: #fff;
  margin-bottom: 4px;
  padding: 0 0 100%;
  position: relative;
  transition: 0.2s;
  width: 100%;
  display: block;
  border: 0;
  outline: 0;
  border-radius: 0;
  cursor: pointer;
}

.icon-list__btn:hover,
.icon-list__btn:focus {
  color: #007eff;
  --color: #007eff;
  --secondary: #cce8ff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.icon-list__btn:active {
  box-shadow: 0 0 0 transparent, inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.icon-list__icon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transition: fill 0.3s;
}
</style>